import NameCell from './NameCell';
import {
  hasNoPlatformAccounts,
  noPlatformAccountsReason,
} from './NameCell/noPlatformAccounts';
import type { TeamTableColumns } from '../hooks/useTeamsColumns';

interface CellProps {
  rowData: TeamTableColumns;
}

export default function TeamsPageNameCell({ rowData }: CellProps) {
  const hasNoAccounts = hasNoPlatformAccounts(rowData.platformAccounts);

  return (
    <NameCell
      rowData={rowData}
      disabled={hasNoAccounts}
      disabledReason={hasNoAccounts ? noPlatformAccountsReason() : undefined}
    />
  );
}
